import { api } from '../config/api';

export interface PopupEducativo {
  id: string;
  titulo: string;
  conteudo: string;
  ordem: number;
  ativo: boolean;
  criado_em: string;
  atualizado_em: string;
}

export interface PopupsConfig {
  ativo: boolean;
  intervalo_minutos: number;
  perfis_permitidos: string[];
}

export class PopupsEducativosService {
  // Buscar configuração de popups
  static async buscarConfig(): Promise<PopupsConfig> {
    try {
      const response = await api.get('/popups-educativos/config');
      return response.data?.data || { ativo: false, intervalo_minutos: 5, perfis_permitidos: [] };
    } catch (error) {
      console.error('Erro ao buscar config de popups:', error);
      return { ativo: false, intervalo_minutos: 5, perfis_permitidos: [] };
    }
  }

  // Atualizar configuração de popups
  static async salvarConfig(config: PopupsConfig): Promise<{ error: any }> {
    try {
      await api.put('/popups-educativos/config', config);
      return { error: null };
    } catch (error: any) {
      return { error: error.message || 'Erro ao salvar configuração' };
    }
  }

  // Buscar popups ativos (para exibição)
  static async buscarAtivos(): Promise<PopupEducativo[]> {
    try {
      const response = await api.get('/popups-educativos');
      return response.data?.data || [];
    } catch (error) {
      console.error('Erro ao buscar popups ativos:', error);
      return [];
    }
  }

  // Buscar todos os popups (admin)
  static async buscarTodos(): Promise<PopupEducativo[]> {
    try {
      const response = await api.get('/popups-educativos/admin');
      return response.data?.data || [];
    } catch (error: any) {
      console.error('Erro ao buscar popups:', error);
      return [];
    }
  }

  // Criar popup
  static async criar(popup: Omit<PopupEducativo, 'id' | 'criado_em' | 'atualizado_em'>): Promise<{ error: any }> {
    try {
      await api.post('/popups-educativos', popup);
      return { error: null };
    } catch (error: any) {
      return { error: error.message || 'Erro ao criar popup' };
    }
  }

  // Atualizar popup
  static async atualizar(id: string, popup: Partial<PopupEducativo>): Promise<{ error: any }> {
    try {
      await api.put(`/popups-educativos/${id}`, popup);
      return { error: null };
    } catch (error: any) {
      return { error: error.message || 'Erro ao atualizar popup' };
    }
  }

  // Excluir popup
  static async excluir(id: string): Promise<{ error: any }> {
    try {
      await api.delete(`/popups-educativos/${id}`);
      return { error: null };
    } catch (error: any) {
      return { error: error.message || 'Erro ao excluir popup' };
    }
  }

  // Popular popups padrão
  static async popularPadrao(): Promise<{ error: any }> {
    try {
      await api.post('/popups-educativos/seed', {});
      return { error: null };
    } catch (error: any) {
      return { error: error.message || 'Erro ao popular popups padrão' };
    }
  }
}
